import { FormType } from '../../../form-types';

export const prep: FormType = {
  name: 'Prep',
  questions: [
    'prep_disclosure',
    {
      key: 'prep_hiv',
      next: {
        condition: { 'prep_hiv.yes': true },
        key: 'prep_ineligible',
        els: 'prep_before'
      }
    },
    {
      key: 'prep_before',
      next: {
        condition: { 'prep_before.yes': true },
        key: 'prep_currentBefore',
        els: 'prep_partners'
      }
    },
    'prep_ineligible',
    {
      key: 'prep_currentBefore',
      next: {
        switch: [
          {
            condition: { 'prep_currentBefore.yes_currently': true },
            key: 'prep_drug_current'
          },
          {
            condition: { 'prep_currentBefore.yes_previously': true },
            key: 'prep_drug_previous'
          }
        ],
        els: 'prep_partners'
      }
    },
    {
      key: 'prep_drug_current',
      next: {
        key: 'prep_partners'
      }
    },
    'prep_drug_previous',
    'prep_partners',
    'prep_partnersHIV',
    'prep_receptive',
    'prep_insertive',
    'prep_meth',
    'prep_poppers',
    'prep_medicalConditions',
    'prep_fluLikeSymptoms',
    'prep_boneHealthRisk',
    'prep_medications',
    'prep_complete'
  ]
};
